import ApiResponse from "src/interfaces/ApiResponse";
import api from "./api";

export function MenuService() {
  return api.get<ApiResponse>(
    process.env.REACT_APP_API_BASE_URL_MENU + "/item/buscar-por-perfil"
  );
}
